<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt1">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="crt"><span class="small">THOMAS DUNNE BOOKS.</span><br/>An imprint of St. Martin’s Press.</p>
<p class="crt1"><span class="small">GODCHILDREN.</span> Copyright © 2002 by Nicholas Coleridge. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="crt"><a class="pubhlink" href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a><br/><a class="pubhlink" href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="crt1">  <span class="small">LIBRARY OF CONGRESS C AT ALOGING-IN-PUBLICATION DATA</span></p>
<p class="crt1">Coleridge, Nicholas, 1957—</p>
<p class="crt1">    Godchildren / Nicholas Coleridge.—1st U.S. ed.<br/>         p. cm.<br/>    ISBN-13: 978-0-312-38258-2<br/>    ISBN-10: 0-312-38258-8<br/>    1. Family secrets—Fiction. 2. Domestic fiction. I. Title.<br/>    PR6053.O4218G63 2008<br/>    823′.914—dc22</p>
<p class="right">2008019639</p>
<p class="crt">First published in Great Britain by Orion Books Ltd.</p>
<p class="crt">First U.S. Edition: September 2008</p>
<p class="crt">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312382582_epub_cop_r1.vue?cca50920